export const SINGLE_WMS_REQUEST = "SINGLE_WMS_REQUEST";

export function invokeSingleWmsRequestAction(baselineLayer: any, workspaceLayer: any) {
    return {
        type: SINGLE_WMS_REQUEST,
        baselineLayer: baselineLayer,
        workspaceLayer: workspaceLayer,
    };
}
